import { render } from "./PredictionList.vue?vue&type=template&id=5bc89ae5&scoped=true"
import script from "./PredictionList.vue?vue&type=script&lang=js"
export * from "./PredictionList.vue?vue&type=script&lang=js"

import "./PredictionList.vue?vue&type=style&index=0&id=5bc89ae5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc89ae5"]])

export default __exports__